export class JsonPathSample {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampleValue",
            "baseName": "sampleValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "isString",
            "baseName": "isString",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "looksLike",
            "baseName": "looksLike",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JsonPathSample.attributeTypeMap;
    }
    constructor() {
    }
}
